import React, { useMemo, useCallback, Fragment } from 'react';
import shortid from 'shortid';
import styled, { css } from '../../styled';
const StyledTd = styled.td `
  ${({ minWidth, textAlign, rowVerticalAlign, offsetLeft, offsetRight }) => css `
    box-sizing: border-box;
    min-width: ${`${minWidth}rem`};
    width: ${`${minWidth}rem`};
    font-size: 0.875rem;
    padding: 0.75rem 0.5rem;
    text-align: ${textAlign || 'left'};
    vertical-align: ${rowVerticalAlign};
    left: ${offsetLeft ? `${offsetLeft}rem` : 0};
    right: ${`${offsetRight}rem`};
  `}
`;
const StyledTr = styled.tr `
  ${({ theme, checked }) => css `
    & > td {
      ${checked && `background-color:${theme.colors.PRIMARY_200} !important`}
    }
  `}
`;
const CollapseTr = styled(StyledTr) `
  ${({ expand }) => css `
    display: ${expand ? 'table-row' : `none`};
  `}
`;
const CollapseIconTd = styled(StyledTd) `
  ${({ expand }) => css `
    svg {
      ${expand && 'transform: rotate(90deg)'};
    }
  `}
`;
const StyledTbody = styled.tbody `
  ${({ theme, hoverable, rowHeight }) => css `
    tr {
      height: ${`${rowHeight}rem`};
      transition: 0.2s;
      &:not(:last-child) {
        border-bottom: solid 0.0625rem ${theme.colors.INK_200};
      }
      ${hoverable &&
    `
        &:not(${CollapseTr}):hover {
          ${StyledTd}{
            background-color: ${theme.colors.PRIMARY_100};
          }
        }
        &:not(${CollapseTr}):active {
          ${StyledTd}{
            background-color: ${theme.colors.PRIMARY_200};
          }
        }
      `}
    }
  `}
`;
const TableBody = ({ columns, dataSource, columnConfig, hoverable, renderIndex, fixedClasses, rowVerticalAlign, onTableRowClick, rowHeight, expandRows, collapseIcon, collapseRowStyle, e2eId, }) => {
    const indexClasses = useMemo(() => Object.keys(columnConfig.fixedColumns).length ? fixedClasses.column : '', [columnConfig.fixedColumns, fixedClasses.column]);
    const getFixedClasses = useCallback((key) => {
        const classes = [];
        if (columnConfig.fixedColumns[key]) {
            classes.push(fixedClasses.column);
        }
        if (columnConfig.fixedLeftShadowColumnKey.includes(key)) {
            classes.push(fixedClasses.columnLeft);
        }
        if (columnConfig.fixedRightShadowColumnKey.includes(key)) {
            classes.push(fixedClasses.columnRight);
        }
        return classes.join(' ');
    }, [columnConfig, fixedClasses]);
    const getColumnsKeyAndWidth = (columnsAry) => {
        return columnsAry.map(item => ({ key: item.key, width: item.width }));
    };
    const buildTd = (data) => getColumnsKeyAndWidth(columns).map(({ key, width }) => (React.createElement(StyledTd, { key: key, className: getFixedClasses(key), textAlign: columnConfig.fixedColumnAlign[key], rowVerticalAlign: rowVerticalAlign, offsetLeft: columnConfig.fixedOffsetLeft[key], offsetRight: columnConfig.fixedOffsetRight[key], minWidth: width }, typeof data[key] === 'function' ? data[key]() : data[key])));
    const buildCollapseRow = (source, expand) => {
        const renderRow = (columnsElement) => {
            return (React.createElement(CollapseTr, { key: shortid.generate(), expand: expand, style: collapseRowStyle }, columnsElement));
        };
        if (typeof source.collapsePanel === 'function') {
            return renderRow(React.createElement("td", { colSpan: columns.length + (collapseIcon ? 1 : 0) }, source.collapsePanel()));
        }
        if (Array.isArray(source.collapsePanel)) {
            return source.collapsePanel.map(data => renderRow(React.createElement(React.Fragment, null,
                collapseIcon && React.createElement(StyledTd, null),
                buildTd(data))));
        }
        return null;
    };
    const isExpand = (rows, index) => rows && rows.indexOf(index) !== -1;
    return (React.createElement(StyledTbody, { hoverable: hoverable, rowHeight: rowHeight }, dataSource.map((source, index) => (React.createElement(Fragment, { key: source.id || shortid.generate() },
        React.createElement(StyledTr, { key: source.id || shortid.generate(), onClick: event => onTableRowClick ? onTableRowClick(event, source, index) : null, checked: source.checked, "data-e2e-id": e2eId },
            collapseIcon && (React.createElement(CollapseIconTd, { expand: isExpand(expandRows, index) }, collapseIcon())),
            renderIndex && (React.createElement(StyledTd, { rowVerticalAlign: rowVerticalAlign, className: indexClasses }, renderIndex(index + 1))),
            buildTd(source)),
        buildCollapseRow(source, isExpand(expandRows, index)))))));
};
export default React.memo(TableBody);
//# sourceMappingURL=TableBody.js.map